import React, { useContext } from 'react';
import { Context as AuthContext } from '../../contexts/AuthContext'
import { useParams } from 'react-router-dom';
import { themeColors } from '../../constants'
import {
  useHistory,
  useAccountingBook,
} from '../../hooks'
import {
  FullPageLoader,
  PageHeader,
  TopRightIcon,
  FilterPaymentForm,
  Separater
} from '../../components'

const PaymentFilterPage = () => {
  const history = useHistory();
  const { group_id, accounting_book_id } = useParams()
  const { state: authState } = useContext(AuthContext)
  const [users, accountingBookDetails, loading] = useAccountingBook(authState)

  const handleBack = () => {
    history.navigateTo("paymentIndexPage", { group_id, accounting_book_id })
  }

  return(
    <>
      <TopRightIcon
        clicked={handleBack}
        style={{ fontSize: '20px', right: '20px', color: 'black' }} >
        <div> 確認 </div>
      </TopRightIcon>
      <PageHeader color={themeColors.gray400}>
        從 <span style={{ color: themeColors.green700, paddingLeft: '4px', paddingRight: '4px' }}>{ accountingBookDetails.name ? `${accountingBookDetails.name} ` : '' }</span>  篩選帳款
      </PageHeader>
      <Separater style={{ margin: 0 }}/>
      {
        loading ?
          <FullPageLoader /> :
          <>
            <FilterPaymentForm
              changed={()=> {}}
              users={users.filter(u => u.coverCost)}
              onClosedClick={(v) => () => {}}
            />
          </>
      }
    </>
  )
}

export default PaymentFilterPage;
